<script lang="ts">
	import type { PoiData } from '$lib/components/pois/types';
	import { getMapLayoutContext } from '$lib/components/map/map-layout-context';
	import ButtonMarker from '$lib/components/map/markers/ButtonMarker.svelte';
	import PoiMarkerContent from '$lib/components/map/markers/markerContent/PoiMarkerContent.svelte';

	interface Props {
		poi: PoiData;
		detailedView?: boolean;
		onclick?: (poi: PoiData) => void;
	}

	const { poi, detailedView = false, onclick }: Props = $props();
	const { hoveredPoiId } = getMapLayoutContext();

	function handleMarkerClick() {
		onclick?.(poi);
	}
	const hoverPoiId = $derived($hoveredPoiId);
	const isHovered = $derived(hoverPoiId === poi.id);

	function setHoveredPoiId(poiId: string | null) {
		$hoveredPoiId = poiId;
	}
</script>

<ButtonMarker
	lngLat={[poi.coordinates.lng, poi.coordinates.lat]}
	markerOptions={{
		anchor: 'bottom',
		// Add an offset to the marker to account for the height of the marker arrow.
		offset: [0, -4],
	}}
	class={['absolute z-infront rd-1 bg-transparent', isHovered && 'z-float']}
	ariaLabel={poi.name}
	onclick={handleMarkerClick}
>
	<PoiMarkerContent
		{poi}
		{detailedView}
		{isHovered}
		tag="span"
		iconTag="span"
		onmouseenter={() => setHoveredPoiId(poi.id)}
		onmouseleave={() => setHoveredPoiId(null)}
	/>
</ButtonMarker>
